// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1barp","form":"styles_form__3BIVI"};